import './wp-refund-by-order-info.scss';

import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';

import WpBaseComponent from './../wp-base-component';
import { ActionResult, IHelpDeskService, HelpDeskSymbols, INotificationService, NotificationSymbols, AppSettings } from 'web-platform-help-desk-core-frontend-ui';
import { Order } from 'web-platform-help-desk-core-frontend-ui/src/HelpDesk/order-info';
import { ModuleType } from 'web-platform-help-desk-core-frontend-ui/src/Global/module-type';

@Component({
    template: require("./wp-refund-by-order-info.html")
})

export default class WpRefundByOrderInfo extends mixins(WpBaseComponent, Vue) {
    protected _service!: IHelpDeskService;
    protected _notificationService!: INotificationService;

    Email: string = "";
    PhoneNumber: string = "+7";
    SearchMethod: number = 0;
    Code: string = "";
    HintVisible: boolean = false;

    Title: string = "Данные по заказу";
    DisabledUI: boolean = false;
    FormIsValid: boolean = false;

    get PhoneRules() {
        return [
            (v: string) => (/^(\s*)?(\+)?([- _():=+]?\d[- _():=+]?){11,14}(\s*)?$/.test(v))
        ];
    };
    get PhoneEnabled() {
        return AppSettings.PhoneFieldEnabled;
    }

    RemoveCodeWhiteSpace() {
        this.$nextTick(() => {
            this.Code = this.Code.replace(/ /g, "");
        });
    };

    RemoveEmailWhiteSpace() {
        this.$nextTick(() => {
            this.Email = this.Email.replace(/ /g, "");
        });
    };

    Rules: Object = {
        Email: [
            (val: any) => (val || '').length > 0 || "Обязательное поле",
            (v: string) => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || "Неверный формат E-mail",
        ],
        Name: [
            (val: any) => (val || '').length > 0 || "Обязательное поле",
        ],
        Phone: [
            (val: any) => (val || '').length == 16 || "Неверный формат номера телефона",
        ],
        Code: [
            (val: any) => (val || '').length > 0 || "Обязательное поле",
        ],
    };

    ScreenShot1: string = require("@/assets/screenshot001.png");

    DialogSearchResult: boolean = false;
    SearchResult: Order | null = null;

    created(): void {
        this._service = this.GlobalService.Get<IHelpDeskService>(HelpDeskSymbols.HelpDeskService);
        this._notificationService = this.GlobalService.Get<INotificationService>(NotificationSymbols.NotificationService);

        if (window.location.href.includes('sign') && window.location.href.includes('orderId') && window.location.href.includes('email') && window.location.href.includes('phone')) {
            let params = window.location.href.split('?')[1];
            let sign = params.split('&')[0].replace('sign=', '');
            let orderId = params.split('&')[1].replace('orderId=', '');

            let email = params.split('&')[2].replace('email=', '');
            if (email.includes('%40')) {
                email = email.replace('%40', '@');
            };

            let phone = params.split('&')[3].replace('phone=', '');
            if (phone.includes('%20')) {
                phone = phone.replace('%20', '+');
            };

            if (phone.startsWith('8')) {
                phone = phone.replace('8', '+7');
            };

            this._service.FindByLinkParametersAsync(sign, parseInt(orderId), email, this.PhoneEnabled ? phone : "").then((result) => {
                if (result.Success) {
                    this.SearchResult = result.Data!;
                    this.DialogSearchResult = true;
                } else {
                    this._notificationService.Error("Ошибка", result.ErrorMessage || "Не удалось найти информацию о заказе");
                };
            });
        };
    };

    PhoneFocus(value: string): void {
        console.log(value);
        this.PhoneNumber = "+7";

        if (value.length < 2) {
            this.$nextTick(() => {
                this.PhoneNumber = "+7" + value;
            });
        };

        if (value.startsWith('7')) {
            value = value.replace('7', '');
            console.log(value);
            this.PhoneNumber += value;
        };

        if (value.startsWith('8')) {
            value = value.replace('8', '');
            console.log(value);
            this.PhoneNumber += value;
        };
    };

    protected async GetDataByOrderInfo(): Promise<ActionResult> {
        this.DisabledUI = true;
        this.Email = this.Email.trimStart().trimEnd()

        if (this.SearchMethod == 0) {
            if (this.Code.includes('_')) {
                this._notificationService.Error("Ошибка", "Укажите корректный номер заказа");
            } else {
                let result = await this._service.FindByCodeAsync(parseInt(this.Code), this.Email, this.PhoneEnabled ? this.NormalizedPhone() : "");
                if (result.Success && result.Data != null) {
                    this.SearchResult = result.Data;
                    this.DialogSearchResult = true;
                } else {
                    this._notificationService.Error("Ошибка", result.ErrorMessage || "Не удалось найти информацию о заказе");
                };
            }
        } else {
            if (this.Code.includes('_')) {
                let result = await this._service.FindByIdAsync(this.Code, this.Email, this.NormalizedPhone());
                if (result.Success && result.Data != null) {
                    this.SearchResult = result.Data;
                    this.DialogSearchResult = true;
                } else {
                    this._notificationService.Error("Ошибка", result.ErrorMessage || "Не удалось найти информацию о заказе");
                };
            } else {
                this._notificationService.Error("Ошибка", "Укажите корректный номер платежа");
            };
        };

        this.DisabledUI = false;
        return ActionResult.Success();
    };

    NormalizedPhone(): string {
        let phone = this.PhoneNumber.replace('(', '').replace(')', '').replace('-', '').replace('-', '');
        return phone;
    };
};

